module.exports = __webpack_public_path__ + "7dd06b14cf008dc8cc3c275777455440.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/home/static/quick-books-logo.png
// module id = 5190
// module chunks = 25